import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { TenantComponentsState } from '../../states/tenant-components.state';
import { GetMyTenantComponentsUseCase } from '../get-my-tenant-components/get-my-tenant-components.use-case';

/**
 * Load Tenant Components Use Case.
 *
 * Hydration trigger for the tenant components state: fetches the tenant's product
 * flags from the API once (no-op if already loaded) and populates the state.
 * Read the values via GetTenantComponentsStateUseCase.
 */
@Injectable({ providedIn: 'root' })
export class LoadTenantComponentsUseCase {
  private readonly _state = inject(TenantComponentsState);
  private readonly _getMyComponents = inject(GetMyTenantComponentsUseCase);

  public execute(): Observable<void> {
    if (this._state.isLoaded() || this._state.loadFailed()) {
      return of(undefined);
    }
    return this._getMyComponents.execute().pipe(
      tap((result) => {
        if (result.success && result.data) {
          this._state.set(
            result.data.sharedServicesPortalEnabled ?? false,
            result.data.employeeRelationsPortalEnabled ?? false,
            result.data.employeePortalEnabled ?? false,
          );
        } else {
          this._state.setLoadFailed();
        }
      }),
      map(() => undefined),
    );
  }
}
